import React, { useCallback } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import FormikTextField from './FormikTextField';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { createUseStyles } from 'react-jss';

import Modal from 'react-bootstrap/Modal';
import FormikErrorMessage from './FormikErrorMessage';
import Text from './Text';
import Button from './Button';
import { hideAuthModals } from '../actions/ui';
import { RootState } from '../config/store';
import { loginUser } from '../services/ApiService';
import {  loginLocally, logoutLocally } from '../actions/auth';
import { formatJoiError } from '../lib/utils';

export interface ConfirmationModalProps { }

const formSchema = Yup.object()
  .shape({
    email: Yup.string()
      .email()
      .required(),
    password: Yup.string().required(),
  })
  .required();

const ConfirmationModal: React.FC<ConfirmationModalProps> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const show = useSelector<RootState, boolean>(
    (state) => state.ui.showConfirmationModal,
  );

  const onHide = useCallback(() => {
    dispatch(hideAuthModals());
  }, [dispatch]);

  const logOut = useCallback(
    () => {
      return (async () => {
        try {
          logoutLocally();
          dispatch(hideAuthModals());
          window.location.reload(false);
        } catch (e) {
        }
      })();
    },
    [dispatch],
  );

  return (
    <Modal
      dialogClassName={clsx(classes.modal, 'auth-modal')}
      centered
      show={show}
      onHide={onHide}
    >
      <Modal.Header className={classes.header} closeButton>
        <Modal.Title>
          <Text className="m-0" color="white">
            Logout
          </Text>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4">
        <Text
          className={clsx(classes.paragraph, 'mb-4')}
          uppercase
        >
          Are You Sure you want logout
              </Text>
        <Button
          type="button"
          block
          onClick={logOut}
          className={classes.logoutBtn}
        >
          <Text className="m-0" color="white">
            Logout
                </Text>
        </Button>
        <Button
          type="button"
          block
          onClick={onHide}
          className={clsx(classes.logoutBtn, classes.cancelBtn)}
        >
          <Text className="m-0" color="white">
            Cancel
                </Text>
        </Button>
      </Modal.Body>
    </Modal>
  );
};

const useStyles = createUseStyles({
  modal: {
    width: '100%',
    maxWidth: '500px',
  },
  header: {
    borderRadius: '5px !important',
    backgroundColor: '#9D7CFA',
    borderBottomLeftRadius: '0 !important',
    borderBottomRightRadius: '0 !important',
  },
  input: {
    marginBottom: '2rem',
  },
  paragraph: {
    color: '#9D7CFA',
    '&:hover': {
      color: '#9D7CFA',
    },
    '&:visited': {
      color: '#9D7CFA !important',
    },
  },
  termsBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '2rem',
  },
  logoutBtn: {
    margin: '10px 0px'
  },
  cancelBtn: {
    backgroundColor: '#9d7cfa'
  },
  tomato: {
    color: 'tomato !important',
  },
});

export default ConfirmationModal;
